module.exports = __webpack_public_path__ + "static/media/instagram-icon.a51906fd.png";